var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 33,
    viewBox: "0 0 20 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.91675V31.0834M17.2917 6.29175H6.35417C5.00046 6.29175 3.70219 6.82951 2.74498 7.78672C1.78776 8.74394 1.25 10.0422 1.25 11.3959C1.25 12.7496 1.78776 14.0479 2.74498 15.0051C3.70219 15.9623 5.00046 16.5001 6.35417 16.5001H13.6458C14.9995 16.5001 16.2978 17.0378 17.255 17.9951C18.2122 18.9523 18.75 20.2505 18.75 21.6042C18.75 22.958 18.2122 24.2562 17.255 25.2134C16.2978 26.1707 14.9995 26.7084 13.6458 26.7084H1.25",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/vector-8.73d2363c7054e8c627b3b69af23aa1ee.svg";
export { ForwardRef as ReactComponent };